/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type { TelegramExchangeRateControllerFindAllQueryResponse } from '../../types/TelegramExchangeRateControllerFindAll.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { telegramExchangeRateFindAll } from '../../methods/telegramExchangeRateFindAll.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const telegramExchangeRateFindAllQueryKey = () => [{ url: '/api/telegram/exchange-rates' }] as const;

export type TelegramExchangeRateFindAllQueryKey = ReturnType<typeof telegramExchangeRateFindAllQueryKey>;

export function telegramExchangeRateFindAllQueryOptions(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = telegramExchangeRateFindAllQueryKey();
  return queryOptions<
    TelegramExchangeRateControllerFindAllQueryResponse,
    ResponseErrorConfig<Error>,
    TelegramExchangeRateControllerFindAllQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return telegramExchangeRateFindAll(config);
    },
  });
}

/**
 * {@link /api/telegram/exchange-rates}
 */
export function useTelegramExchangeRateFindAll<
  TData = TelegramExchangeRateControllerFindAllQueryResponse,
  TQueryData = TelegramExchangeRateControllerFindAllQueryResponse,
  TQueryKey extends QueryKey = TelegramExchangeRateFindAllQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        TelegramExchangeRateControllerFindAllQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? telegramExchangeRateFindAllQueryKey();

  const query = useQuery(
    {
      ...telegramExchangeRateFindAllQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
